/**
 * Icone disegnate a mano in SVG: nessuna libreria esterna, nessuna richiesta di rete.
 * Tratto uniforme (1.7), dimensione ereditata dal CSS.
 */
type Props = { className?: string }

const base = {
  viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.7, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
  'aria-hidden': true,
}

export const IconaCruscotto = (p: Props) => (
  <svg {...base} {...p}><rect x="3" y="3" width="7" height="8" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" /><rect x="14" y="11" width="7" height="10" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /></svg>
)
export const IconaPersone = (p: Props) => (
  <svg {...base} {...p}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
)
export const IconaInterventi = (p: Props) => (
  <svg {...base} {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M9 15h6" /><path d="M9 11h3" /></svg>
)
export const IconaCalendario = (p: Props) => (
  <svg {...base} {...p}><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
)
export const IconaGruppo = (p: Props) => (
  <svg {...base} {...p}><circle cx="12" cy="8" r="3" /><circle cx="5" cy="15" r="2.5" /><circle cx="19" cy="15" r="2.5" /><path d="M12 11v4M8 19h8" /></svg>
)
export const IconaEnti = (p: Props) => (
  <svg {...base} {...p}><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 21v-6h6v6" /><path d="M9 10h.01M15 10h.01" /></svg>
)
export const IconaServiziErogati = (p: Props) => (
  <svg {...base} {...p}><path d="M4 4h16v12H7l-3 3z" /><path d="M8 9h8M8 12h5" /></svg>
)
export const IconaMediatori = (p: Props) => (
  <svg {...base} {...p}><path d="m5 8 6 6" /><path d="m4 14 6-6 2-3" /><path d="M2 5h12M7 2h1" /><path d="m22 22-5-10-5 10M14 18h6" /></svg>
)
export const IconaProgetti = (p: Props) => (
  <svg {...base} {...p}><path d="M4 20h16" /><rect x="4" y="4" width="6" height="5" rx="1" /><rect x="10" y="11" width="8" height="5" rx="1" /></svg>
)
export const IconaMessaggi = (p: Props) => (
  <svg {...base} {...p}><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.9-.9L3 21l1.9-5a8.4 8.4 0 0 1-.9-3.9 8.4 8.4 0 0 1 8.4-8.4h.5a8.4 8.4 0 0 1 8.1 8.1z" /></svg>
)
export const IconaCampana = (p: Props) => (
  <svg {...base} {...p}><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.7 21a2 2 0 0 1-3.4 0" /></svg>
)
export const IconaReport = (p: Props) => (
  <svg {...base} {...p}><path d="M3 3v18h18" /><path d="M7 15l4-5 3 3 5-7" /></svg>
)
export const IconaRegistro = (p: Props) => (
  <svg {...base} {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></svg>
)
export const IconaApprovazioni = (p: Props) => (
  <svg {...base} {...p}><path d="M9 11l3 3 8-8" /><path d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9" /></svg>
)
export const IconaAmministrazione = (p: Props) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6h.09A1.65 1.65 0 0 0 10.6 3.09V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>
)
export const IconaMigrazione = (p: Props) => (
  <svg {...base} {...p}><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5" /><path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" /></svg>
)
export const IconaCerca = (p: Props) => (
  <svg {...base} {...p}><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>
)
export const IconaPiu = (p: Props) => (
  <svg {...base} {...p}><path d="M12 5v14M5 12h14" /></svg>
)
export const IconaMenu = (p: Props) => (
  <svg {...base} {...p}><path d="M4 6h16M4 12h16M4 18h16" /></svg>
)
// Webmail a tutta pagina (2/11/2026): colonna delle caselle, lettura ingrandita, nuova scheda.
export const IconaColonna = (p: Props) => (
  <svg {...base} {...p}><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16" /></svg>
)
export const IconaIngrandisci = (p: Props) => (
  <svg {...base} {...p}><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" /></svg>
)
export const IconaRiduci = (p: Props) => (
  <svg {...base} {...p}><path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7" /></svg>
)
export const IconaNuovaScheda = (p: Props) => (
  <svg {...base} {...p}><path d="M14 4h6v6M20 4l-9 9" /><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" /></svg>
)
export const IconaChiudi = (p: Props) => (
  <svg {...base} {...p}><path d="M18 6 6 18M6 6l12 12" /></svg>
)
export const IconaEsci = (p: Props) => (
  <svg {...base} {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5M21 12H9" /></svg>
)
export const IconaLucchetto = (p: Props) => (
  <svg {...base} {...p}><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></svg>
)
export const IconaAvviso = (p: Props) => (
  <svg {...base} {...p}><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4M12 17h.01" /></svg>
)
export const IconaInfo = (p: Props) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="9" /><path d="M12 16v-4M12 8h.01" /></svg>
)
export const IconaFatto = (p: Props) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="9" /><path d="m8.5 12.5 2.5 2.5 4.5-5" /></svg>
)
export const IconaDocumento = (p: Props) => (
  <svg {...base} {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /></svg>
)
export const IconaScarica = (p: Props) => (
  <svg {...base} {...p}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5M12 15V3" /></svg>
)
export const IconaCarica = (p: Props) => (
  <svg {...base} {...p}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 8 5-5 5 5M12 3v12" /></svg>
)
export const IconaOrologio = (p: Props) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
)
export const IconaVuoto = (p: Props) => (
  <svg {...base} {...p}><path d="M21 8v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8" /><path d="M1 8h22l-2-5H3z" /><path d="M10 12h4" /></svg>
)

export const IconaBusta = (p: Props) => (
  <svg {...base} {...p}><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m2 7 10 6 10-6" /></svg>
)

export const IconaRegistrazione = (p: Props) => (
  <svg {...base} {...p}><rect x="2" y="6" width="13" height="12" rx="2" /><path d="m22 8-5 4 5 4z" /><circle cx="8.5" cy="12" r="2.5" /></svg>
)

/* --- webmail ------------------------------------------------------------------------------ */

export const IconaCartella = (p: Props) => (
  <svg {...base} {...p}><path d="M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>
)
export const IconaGraffetta = (p: Props) => (
  <svg {...base} {...p}><path d="M21 11.1 12.3 19.8a5.5 5.5 0 0 1-7.8-7.8l8.7-8.7a3.7 3.7 0 0 1 5.2 5.2l-8.7 8.7a1.8 1.8 0 0 1-2.6-2.6l8-8" /></svg>
)
export const IconaRispondi = (p: Props) => (
  <svg {...base} {...p}><path d="m9 17-5-5 5-5" /><path d="M4 12h11a5 5 0 0 1 5 5v2" /></svg>
)
export const IconaRispondiATutti = (p: Props) => (
  <svg {...base} {...p}><path d="m7 17-5-5 5-5" /><path d="m13 17-5-5 5-5" /><path d="M8 12h8a4 4 0 0 1 4 4v2" /></svg>
)
export const IconaInoltra = (p: Props) => (
  <svg {...base} {...p}><path d="m15 17 5-5-5-5" /><path d="M20 12H9a5 5 0 0 0-5 5v2" /></svg>
)
export const IconaArchivia = (p: Props) => (
  <svg {...base} {...p}><rect x="3" y="3" width="18" height="5" rx="1.5" /><path d="M5 8v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8" /><path d="M10 12h4" /></svg>
)
export const IconaCestino = (p: Props) => (
  <svg {...base} {...p}><path d="M3 6h18" /><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" /><path d="M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14" /><path d="M10 11v6M14 11v6" /></svg>
)
/** Bandierina delle conversazioni (538). Con `piena` la bandiera prende il colore del testo. */
export const IconaBandierina = (p: Props & { piena?: boolean }) => (
  <svg {...base} className={p.className}><path d="M5 21V4" /><path d="M5 4h12l-2.5 4.5L17 13H5" fill={p.piena ? 'currentColor' : 'none'} /></svg>
)
export const IconaEtichetta = (p: Props) => (
  <svg {...base} {...p}><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" /><path d="M7.5 7.5h.01" /></svg>
)
export const IconaRipristina = (p: Props) => (
  <svg {...base} {...p}><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" /></svg>
)
export const IconaCopia = (p: Props) => (
  <svg {...base} {...p}><rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" /></svg>
)
export const IconaScrivi = (p: Props) => (
  <svg {...base} {...p}><path d="M12 20h9" /><path d="M16.4 3.6a2.1 2.1 0 0 1 3 3L7.5 18.5 3 20l1.5-4.5z" /></svg>
)
export const IconaAggancia = (p: Props) => (
  <svg {...base} {...p}><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" /><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" /></svg>
)
export const IconaOcchio = (p: Props) => (
  <svg {...base} {...p}><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></svg>
)
export const IconaImmagine = (p: Props) => (
  <svg {...base} {...p}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="8.5" cy="9.5" r="1.8" /><path d="m4 18 5-4.5 3.5 2.5L16 13l4 4" /></svg>
)
export const IconaIndietro = (p: Props) => (
  <svg {...base} {...p}><path d="m15 18-6-6 6-6" /></svg>
)
export const IconaAggiorna = (p: Props) => (
  <svg {...base} {...p}><path d="M20.5 12a8.5 8.5 0 1 1-2.6-6.1" /><path d="M21 3v5h-5" /></svg>
)
export const IconaTelefono = (p: Props) => (
  <svg {...base} {...p}><rect x="6" y="2" width="12" height="20" rx="2.5" /><path d="M11 18h2" /></svg>
)
